import { Navigate, useLocation } from 'react-router-dom';
import { isAuthenticated } from './session';

export default function RequireAuth({ children }) {
  const location = useLocation();
  if (!isAuthenticated()) {
    return <Navigate to="/login" replace state={{ from: location.pathname }} />;
  }
  return children;
}
